<vn-dialog-content [title]="data.title">
    <div [innerHtml]="data.content | trustAsHtml"></div>
</vn-dialog-content>
